import { createFileRoute, redirect, useRouter } from '@tanstack/react-router'
import { useT } from '@/shared/i18n'
import { z } from 'zod'
import { LoginForm, fetchSession, safeRedirectTarget } from '@/shared/auth'
import { AuthLayout } from '@/widgets/layouts/auth-layout'

const loginSearchSchema = z.object({
  redirect: z.string().optional(),
})

export const Route = createFileRoute('/login')({
  validateSearch: loginSearchSchema,
  beforeLoad: async ({ context, search }) => {
    const { queryClient, auth } = context.services
    const session = await fetchSession(queryClient, auth)
    if (session) throw redirect({ href: safeRedirectTarget(search.redirect) })
  },
  component: LoginPage,
})

function LoginPage() {
  const t = useT()
  const router = useRouter()
  const search = Route.useSearch()

  return (
    <AuthLayout title={t('auth.title')} subtitle={t('auth.subtitle')}>
      <LoginForm
        onSuccess={() => {
          void router.navigate({ href: safeRedirectTarget(search.redirect) })
        }}
        // "Forgot password?" is hidden until the backend sends reset requests (Q31); the
        // /forgot-password route stays for when it returns.
      />
    </AuthLayout>
  )
}
